import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import ExpenseTable from "./ExpenseTable";
import ExpenseHeader from "./ExpenseHeader";
import Input from "../shared/Input";
import { useLocation } from "react-router-dom";
import topTost from "../../utils/topTost";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
const ExpenseList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  const [permission, setPermission] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [formInquiryData, setFormInquiryData] = useState({
    from_date: "",
    to_date: "",
    employID: "",
    expense_category: "",
    status: "",
  });

  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const M_id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", M_id);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;
        setPermission(perm);
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [M_id]);

  const fetchAllData = async () => {
    const userId = localStorage.getItem("id");
    const formData = new FormData();
    formData.append("userId", userId);

    const expenseData = await fetchData(
      "list-expense-category-dropdown",
      {},
      "POST"
    );

    const userData = await fetchFormData(
      "get-employees-listuserdrop",
      formData,
      "POST"
    );

    if (expenseData) {
      const branchData = expenseData.data;
      setExpenseData(getValueLabel(branchData, "expense_category", "id") || []);
    }
    if (userData) {
      const branchData = userData.users;
      setUserData(getValueLabel(branchData, "name", "id") || []);
    }
  };

  const statusOptions = [
    { label: "Pending", value: "0" },
    { label: "Approved", value: "1" },
  ];

  const handleSubmit = async (e) => {
    const userId = localStorage.getItem("id");
    e.preventDefault();
    setIsSubmitting(true);
    if (!formInquiryData.from_date && formInquiryData.to_date) {
      topTost({
        title: "Please select From Date before selecting To Date.",
        icon: "error",
      });
    } else if (formInquiryData.from_date && !formInquiryData.to_date) {
      topTost({
        title: "To Date is required when From Date is selected",
        icon: "error",
      });
    } else if (
      formInquiryData.from_date &&
      formInquiryData.to_date &&
      new Date(formInquiryData.from_date) > new Date(formInquiryData.to_date)
    ) {
      topTost({
        title: "From Date should be less than or equal to To Date",
        icon: "error",
      });
    } else {
      try {
        const form = new FormData();
        form.append("from_date", formInquiryData.from_date);
        form.append("to_date", formInquiryData.to_date);
        form.append("employID", formInquiryData.employID);
        form.append("expense_category", formInquiryData.expense_category);
        form.append("status", formInquiryData.status);
        form.append("moduleId", M_id);
        form.append("userId", userId);

        const response = await fetchFormData(
          "expense/getAll-date-filter",
          form,
          "POST",
          true
        );

        if (response && response.data) {
          console.log("Filtered data:", response.data);
          setFilterData(response.data);
        } else {
          topTost({
            title: response?.message || "No loan settled found",
            icon: "info",
          });
        }
      } catch (error) {
        console.error("Filter submit error:", error);
        topTost({
          title: "Unexpected error occurred",
          icon: "error",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleChange = (name, value) => {
    setFormInquiryData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleExpenseChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        expense_category: selected.value,
      }));
    }
  };

  const handleUserChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        employID: selected.value,
      }));
    }
  };

  const handleStatusChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        status: selected.value,
      }));
    }
  };

  const handleReset = () => {
    setFormInquiryData({
      from_date: "",
      to_date: "",
      employID: "",
      expense_category: "",
      status: "",
    });
    setFilterData([]);
  };
  const handleClose = () => {
    setShowFilters(!showFilters);
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <ExpenseHeader
              onToggleFilter={() => setShowFilters(!showFilters)}
              permission={permission}
            />
          </PageHeader>

          {showFilters && (
            <div className="main-content-top">
              <div className="row">
                <div className="col-lg-12 mt-3">
                  <div className="card stretch stretch-full function-table">
                    <div className="card-body p-10">
                      <form onSubmit={handleSubmit}>
                        <div className="row px-3 mt-3 mb-4">
                          <div className="col-md-2">
                            <label className="fw-semibold py-2">
                              Expense Category:
                            </label>
                          </div>
                          <div className="col-lg-4">
                            <SelectDropdown
                              options={expenseData}
                              selectedOption={
                                expenseData.find(
                                  (opt) =>
                                    opt.value ===
                                    String(formInquiryData.expense_category)
                                ) || null
                              }
                              value={formInquiryData.expense_category}
                              defaultSelect="Select Expense Category"
                              onSelectOption={handleExpenseChange}
                              icon="feather-flag"
                            />
                          </div>
                          <div className="col-md-2">
                            <label className="fw-semibold py-2">
                              Employee:
                            </label>
                          </div>
                          <div className="col-lg-4">
                            <SelectDropdown
                              options={userData}
                              selectedOption={
                                userData.find(
                                  (opt) =>
                                    opt.value ===
                                    String(formInquiryData.employID)
                                ) || null
                              }
                              value={formInquiryData.employID}
                              defaultSelect="Select Employee"
                              onSelectOption={handleUserChange}
                              icon="feather-flag"
                            />
                          </div>
                        </div>
                        <div className="row mb-4 ">
                          <div className="col-lg-6">
                            <Input
                              label="From Date"
                              name="from_date"
                              type="date"
                              value={formInquiryData.from_date}
                              onChange={handleChange}
                              placeholder="From Date"
                              icon="feather-calendar"
                            />
                          </div>
                          <div className="col-lg-6">
                            <Input
                              label="To Date"
                              name="to_date"
                              type="date"
                              value={formInquiryData.to_date}
                              onChange={handleChange}
                              placeholder="To Date"
                              icon="feather-calendar"
                            />
                          </div>
                          <div className="row mb-4 ">
                            <div className="col-md-2">
                              <label className="fw-semibold py-2">Staus:</label>
                            </div>
                            <div className="col-lg-4">
                              <SelectDropdown
                                options={statusOptions}
                                selectedOption={
                                  statusOptions.find(
                                    (opt) =>
                                      opt.value ===
                                      String(formInquiryData.status)
                                  ) || null
                                }
                                value={formInquiryData.status}
                                defaultSelect="Select Status"
                                onSelectOption={handleStatusChange}
                                icon="feather-check"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="customButton gap-xxl-2 my-xxl-2">
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                  onClick={handleClose}
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                  onClick={handleReset}
                                >
                                  Reset
                                </button>

                                <button
                                  type="submit"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? "Submitting..." : "Search"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="main-content">
            <div className="row">
              <ExpenseTable filteredData={filterData} permission={permission} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default ExpenseList;
